import styled from 'styled-components';

export const RfpActionCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.grey_1};

  border-radius: 4px;
  padding: 24px;
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};

  &:hover {
    background-color: ${({ theme }) => theme.colors.purple_5};
    box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};
  }
`;

export const SubmitRfpSuccessActions = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;

export const SubmitRfpModalActions = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  align-items: center;
`;

export const SubmitRfpSuccessActionsPrimary = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
`;
